import { Map } from "immutable";

import * as type from "./actionTypes";

const initState = Map();

const reducer = (config = initState, action) => {
  switch (action.type) {
    case type.SET:
      return config.merge(Map(action.payload));
    default:
      return config;
  }
};

export default reducer;
